import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { PROFILE } from "../lib/content";

export default function Footer() {
  return (
    <footer className="relative border-t border-gold/10 bg-surface" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-serif text-3xl text-gradient-gold mb-4">Dr. Zeenal Punamiya</h3>
          <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
            {PROFILE.tagline}
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <span className="text-xs uppercase tracking-[0.2em] text-gold mb-2">Navigate</span>
          <Link to="/" className="text-muted-foreground hover:text-gold transition-colors text-sm">Home</Link>
          <Link to="/practice" className="text-muted-foreground hover:text-gold transition-colors text-sm">Practice</Link>
          <Link to="/blog" className="text-muted-foreground hover:text-gold transition-colors text-sm">Blogs</Link>
          <Link to="/testimonials" className="text-muted-foreground hover:text-gold transition-colors text-sm">Testimonials</Link>
          <Link to="/book" className="text-muted-foreground hover:text-gold transition-colors text-sm">Book a Consultation</Link>
        </div>

        <div className="flex flex-col gap-3">
          <span className="text-xs uppercase tracking-[0.2em] text-gold mb-2">Connect</span>
          <a href={`mailto:${PROFILE.email}`} className="flex items-center gap-3 text-muted-foreground hover:text-gold transition-colors text-sm" data-testid="footer-email">
            <Mail size={15} /> {PROFILE.email}
          </a>
          <a href={`tel:${PROFILE.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 text-muted-foreground hover:text-gold transition-colors text-sm">
            <Phone size={15} /> {PROFILE.phone}
          </a>
          <span className="flex items-center gap-3 text-muted-foreground text-sm">
            <MapPin size={15} /> {PROFILE.location}
          </span>
          <div className="flex items-center gap-4 mt-3">
            <a href={PROFILE.socials.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin"
               className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors">
              <Linkedin size={16} />
            </a>
            <a href={PROFILE.socials.whatsapp} target="_blank" rel="noreferrer" data-testid="footer-whatsapp"
               aria-label="Chat on WhatsApp"
               className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors">
              <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.888 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.359.101 11.892c0 2.096.549 4.142 1.595 5.945L0 24l6.305-1.654a11.9 11.9 0 005.71 1.457h.005c6.582 0 11.943-5.36 11.945-11.893a11.82 11.82 0 00-3.445-8.461"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-gold/10 py-6 text-center text-xs text-muted-foreground tracking-wide">
        © {new Date().getFullYear()} Dr. Zeenal Punamiya · Healthcare Innovation & Mentorship
      </div>
    </footer>
  );
}
